export enum ROOM_TYPE {
  EMPTY,
  MAIN,
  CANDLE_ROOM_1,
  CANDLE_ROOM_2,
  CANDLE_ROOM_3,
  CANDLE_ROOM_4,
  CANDLE_ROOM_5,
};
